import React from 'react'

const Manual_editar_lealtad_store_card = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Editar lealtad store card para Apple y Google Wallet
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo editar la tarjeta de lealtad para Apple Wallet y Google Wallet dentro del sistema Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Editar_lealtad_store_card_para_Apple_y_Google_Wallet__4xyyNSOlQ6OnphWRx-8U4Q?as=scrollable"
          className="scribe-iframe-general-96"
          width="100%"
          height="11900"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_editar_lealtad_store_card
